import { 
  countPrecedingLineElements, 
  collectTextNodes, 
  splitNodesIntoPages,
  splitTextElementsAcrossPages,
  replaceAllTextElementsWithPages,
  replaceTextElementWithPages
} from './utils';
import { LayoutType } from '../../ExtendedContent/ExtendedContentContainer/layout';

/**
 * 處理 .text 結構的分頁邏輯（原有邏輯）
 */
export const handleTextStructure = (doc, textElements, lineHeight, pageSize, measureContainer, extendedResourceStyle) => {
  let actualTotalPages = 0;
  
  // ===== 新增：計算總行數，如果 <= 8 行就不分頁 =====
  if (textElements.length > 0) {
    const firstTextElement = textElements[0];
    
    // 1. 計算前置元素（標題圖片、<br>）占用的行數
    let precedingLines = 0;
    const allBrElements = Array.from(doc.querySelectorAll('br'));
    const allImages = doc.querySelectorAll('img');
    const allImgDivs = doc.querySelectorAll('div.img');
    const firstImgDiv = allImgDivs.length > 0 ? allImgDivs[0] : null;
    
    // 計算在第一個 .text 之前的 <br> 和 <img> 數量
    allBrElements.forEach(br => {
      if (br.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING) {
        precedingLines += 1;
      }
    });
    
    allImages.forEach(img => {
      const isInFirstImgDiv = firstImgDiv && firstImgDiv.contains(img);
      const isPreceding = img.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING;

      if (isInFirstImgDiv || isPreceding) {
        precedingLines += 1; // 每個標題圖片算1行
      }
    });
    
    // 2. 測量所有 .text 元素的總高度
    let totalContentHeight = 0;
    textElements.forEach((textElement) => {
      const tempDiv = document.createElement('div');
      tempDiv.className = 'text';
      tempDiv.innerHTML = textElement.innerHTML;
      measureContainer.innerHTML = tempDiv.outerHTML;
      totalContentHeight += measureContainer.offsetHeight;
    });
    
    // 2.5. 測量所有 .title 元素的總高度（新增）
    const titleElements = doc.querySelectorAll('.title');
    titleElements.forEach((titleElement) => {
      const tempDiv = document.createElement('div');
      tempDiv.className = 'title';
      tempDiv.innerHTML = titleElement.innerHTML;
      measureContainer.innerHTML = tempDiv.outerHTML;
      totalContentHeight += measureContainer.offsetHeight;
    });
    
    // 3. 計算總行數
    const contentLines = Math.ceil(totalContentHeight / lineHeight);
    const totalLines = precedingLines + contentLines;

    // console.log('=== 預檢查階段：總行數計算 ===');
    // console.log('totalContentHeight (像素)', totalContentHeight);
    // console.log('lineHeight (像素)', lineHeight);
    // console.log('contentLines (行數)', contentLines);
    // console.log('precedingLines (行數)', precedingLines);
    // console.log('totalLines (總行數)', totalLines);
    
    // 4. 如果總行數 <= 8，不分頁，直接返回
    if (totalLines <= pageSize) {
      const allTextElements = doc.querySelectorAll('.text');
      return {
        htmlString: doc.body.innerHTML,
        totalPages: allTextElements.length || 1,
      };
    }
  }

  // 處理第一個 .text 元素，識別標題圖片和其他圖片
  // 先找到第一個 <div class="img">，讓它在整個函數中都可訪問
  const allImgDivs = doc.querySelectorAll('div.img');
  const firstImgDiv = allImgDivs.length > 0 ? allImgDivs[0] : null;
  
  if (textElements.length > 0) {
    const firstTextElement = textElements[0];
    
    // 找到所有圖片
    const allImages = doc.querySelectorAll('img');
    const titleImages = []; // 標題圖片（在第一個 div.img 內的）
    const otherImages = []; // 其他圖片（不在第一個 div.img 內的）
    
    allImages.forEach(img => {
      // 檢查圖片是否在第一個 div.img 內
      if (firstImgDiv && firstImgDiv.contains(img)) {
        titleImages.push(img);
      } else {
        // 檢查圖片是否在第一個 .text 之前（可能是標題圖片但不在 div.img 內）
        const isPreceding = img.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING;
        if (isPreceding) {
          // 在第一個 .text 之前但不是標題圖片的，也視為標題圖片（固定在第一頁）
          titleImages.push(img);
        } else {
          // 其他圖片，需要獨立一頁顯示
          otherImages.push(img);
        }
      }
    });
    
    // 標記非標題圖片，後續會為它們創建獨立分頁
    otherImages.forEach((img, index) => {
      // 將圖片標記為獨立頁面顯示
      img.setAttribute('data-standalone-page', 'true');
      // 暫時隱藏這些圖片，避免影響文字高度測量
      img.style.display = 'none'; 
      // 注意：之後在 display.js 中顯示時，需要把 display 改回來（變成 block 或 inline）
    });
  }
  
  // ===== 計算 .title 元素的實際高度（像素）和行數，用於第一頁扣除 =====
  let titleHeight = 0;
  let titleLines = 0;
  const titleElements = doc.querySelectorAll('.title');
  
  if (titleElements.length > 0) {
    // 方法：直接測量每個 .title 元素的實際高度
    // 建立一個臨時的測量容器，確保樣式正確繼承
    const tempMeasureContainer = document.createElement('div');
    tempMeasureContainer.style.position = 'absolute';
    tempMeasureContainer.style.visibility = 'hidden';
    tempMeasureContainer.style.width = measureContainer.style.width || '100%';
    tempMeasureContainer.className = measureContainer.className + ' plain_text';
    document.body.appendChild(tempMeasureContainer);
    
    // 確保 <br> 標籤不佔用高度的函數
    const applyBrStyles = (container) => {
      const brElements = container.querySelectorAll('br');
      brElements.forEach(br => {
        br.style.display = 'none';
      });
    };
    
    try {
      titleElements.forEach((titleElement) => {
        const tempDiv = document.createElement('div');
        tempDiv.className = 'title';
        tempDiv.innerHTML = titleElement.innerHTML;
        tempMeasureContainer.innerHTML = '';
        tempMeasureContainer.appendChild(tempDiv);
        
        // 重要：隱藏 <br> 標籤，因為實際樣式中 br { display: none; }
        applyBrStyles(tempMeasureContainer);
        
        // 測量單個 .title 元素的高度（此時 <br> 已被隱藏）
        const singleTitleHeight = tempDiv.offsetHeight;
        titleHeight += singleTitleHeight;
        
        // console.log('單個 .title 元素高度（已隱藏 <br>）:', singleTitleHeight, '像素');
      });
      
      titleLines = Math.ceil(titleHeight / lineHeight);
      
      // console.log('=== .title 元素測量 ===');
      // console.log('titleElements 數量', titleElements.length);
      // console.log('titleHeight (總高度像素，已排除 <br>)', titleHeight);
      // console.log('lineHeight (行高像素)', lineHeight);
      // console.log('titleLines (總行數)', titleLines);
      // console.log('計算公式: Math.ceil(titleHeight / lineHeight) = Math.ceil(' + titleHeight + ' / ' + lineHeight + ') = ' + titleLines);
      // console.log('第一頁可用行數應該是: pageSize - titleLines = ' + pageSize + ' - ' + titleLines + ' = ' + (pageSize - titleLines));
    } finally {
      // 清理臨時容器
      document.body.removeChild(tempMeasureContainer);
    }
  } else {
    // console.log('=== .title 元素測量 ===');
    // console.log('未找到 .title 元素');
  }
  // ===== .title 測量結束 =====
  
  // 檢查 doc 中是否有 topic 或 plain_text class，決定使用哪種分頁邏輯
  const hasTopic = extendedResourceStyle === LayoutType.Topic_108_2;
  const hasPlainText = extendedResourceStyle === LayoutType.PlainText;

  // ===== 統一處理：檢查 <div.img> 是否在第一個 .text 之前 =====
  // 這個邏輯對 topic 和 plaintext 都適用
  let shouldAddImgDivOffset = false;
  if (textElements.length > 0 && firstImgDiv) {
    const firstTextElement = textElements[0];
    const isImgDivPreceding = !!(firstImgDiv.compareDocumentPosition(firstTextElement) & Node.DOCUMENT_POSITION_FOLLOWING);
    
    if (isImgDivPreceding) {
      // 檢查 <div.img> 內是否有圖片
      const imagesInImgDiv = firstImgDiv.querySelectorAll('img');
      if (imagesInImgDiv.length > 0) {
        shouldAddImgDivOffset = true; // 需要將第一頁行數減 1
      }
    }
  }
  // ===== 統一處理結束 =====

  // 創建通用的包裝函數，處理 <div.img> 的情況
  const createCountPrecedingLineElementsWrapper = () => {
    return (textElement) => {
      let count = countPrecedingLineElements(textElement);
      
      // 如果是第一個 .text 元素且 <div.img> 在前，需要減 1 行
      const isFirstTextElement = textElement === textElements[0];
      if (isFirstTextElement && shouldAddImgDivOffset) {
        count += 1;
      }
      
      return count;
    };
  };

  if (hasTopic) {
    // 如果有 topic class，使用舊的邏輯：每個 .text div 獨立分頁
    textElements.forEach((textElement) => {
      // 計算前置的 <img> 數量
      let precedingImgCount = countPrecedingLineElements(textElement);
      
      // 統一處理：如果 <div.img> 在第一個 .text 之前，需要減 1 行
      const isFirstTextElement = textElement === textElements[0];
      if (isFirstTextElement && shouldAddImgDivOffset) {
        precedingImgCount += 1;
      }
      
      // 收集 .text 內的所有節點（文字和算式）
      const nodes = collectTextNodes(textElement);
      
      // 按照行數限制切分成多頁
      // 如果是第一個 .text 元素，需要扣除 .title 的高度
      const pages = splitNodesIntoPages(
        nodes, 
        precedingImgCount, 
        pageSize, 
        measureContainer, 
        lineHeight,
        isFirstTextElement ? titleHeight : 0,  // 傳入 title 實際高度（像素）
        isFirstTextElement ? titleLines : 0    // 傳入 title 行數
      );
      
      // 如果有多頁，替換原 .text 元素
      if (pages.length > 1) {
        replaceTextElementWithPages(textElement, pages);
      }
    });
  } else if (hasPlainText) {
    // 如果有 plain_text class，使用新的邏輯：跨 .text div 分頁
    // 這樣可以讓後續 .text div 的內容填充到前一個 .text div 的不滿頁面中
    
    // 創建包裝函數，處理 <div.img> 和 PlainText 類型的情況
    const wrappedCountPrecedingLineElements = (textElement) => {
      let count = countPrecedingLineElements(textElement);
      
      // 統一處理：如果 <div.img> 在第一個 .text 之前，需要減 1 行
      const isFirstTextElement = textElement === textElements[0];
      if (isFirstTextElement && shouldAddImgDivOffset) {
        count += 1;
      }
      
      return count;
    };
    
    const pages = splitTextElementsAcrossPages(
      textElements,
      wrappedCountPrecedingLineElements,  // 使用包裝函數
      collectTextNodes,
      pageSize,
      measureContainer,
      lineHeight,
      titleHeight,  // 傳入 title 實際高度（像素）
      titleLines   // 傳入 title 行數
    );
    
    // 如果原本有多個 .text div，或者分頁後有多頁，都需要替換
    // 這樣可以確保多個 .text div 的內容能夠正確合併
    if (textElements.length > 1 || pages.length > 1) {
      replaceAllTextElementsWithPages(textElements, pages);
    }
  } else {
    // 預設使用新的邏輯（跨 .text div 分頁）
    // 使用通用的包裝函數
    const wrappedCountPrecedingLineElements = createCountPrecedingLineElementsWrapper();
    
    const pages = splitTextElementsAcrossPages(
      textElements,
      wrappedCountPrecedingLineElements,
      collectTextNodes,
      pageSize,
      measureContainer,
      lineHeight,
      titleHeight,  // 傳入 title 實際高度（像素）
      titleLines   // 傳入 title 行數
    );
    
    if (textElements.length > 1 || pages.length > 1) {
      replaceAllTextElementsWithPages(textElements, pages);
    }
  }

  // 計算總頁數：統計所有 .text 元素（包括分頁後新增的）
  const allTextElements = doc.querySelectorAll('.text');
  actualTotalPages = allTextElements.length;

  // 為非標題圖片創建獨立分頁
  const standaloneImages = doc.querySelectorAll('img[data-standalone-page="true"]');
  if (standaloneImages.length > 0) {
    standaloneImages.forEach((img) => {
      img.style.display = 'block'; // 恢復原狀
    });
    const lastTextElement = allTextElements[allTextElements.length - 1];
    const lastTextParent = lastTextElement.parentNode;
    
    standaloneImages.forEach((img, index) => {
      // 為每個圖片創建一個獨立的 .text 分頁
      const imageTextDiv = doc.createElement('div');
      imageTextDiv.className = 'text';
      
      // 依畫面分類設置頁面索引屬性，用於後續顯示控制
      if (extendedResourceStyle === 'PlainText') {
        img.setAttribute('data-page-index', String(actualTotalPages + index));
      } else {
        img.setAttribute('data-page-index', String(actualTotalPages + index));
      }
      // 在最後一個 .text 之後插入新的分頁
      if (lastTextElement.nextSibling) {
        lastTextParent.insertBefore(imageTextDiv, lastTextElement.nextSibling);
      } else {
        lastTextParent.appendChild(imageTextDiv);
      }
    });
    
    // 更新總頁數
    actualTotalPages += standaloneImages.length;
  }

  // 處理內容圖片：找到在第一個 .text 之後，但不在任何 .text 內部的圖片
  if (allTextElements.length > 0) {
    const firstTextElement = allTextElements[0];
    const lastTextElementAtThisPoint = allTextElements[allTextElements.length - 1];
    
    // 找到內容圖片（不在第一個.text之前，不在最後一個.text之後，不在任何.text內部）
    const contentImages = [];
    const allImages = doc.querySelectorAll('img');
    
    allImages.forEach((img, index) => {
      // 跳過已經標記為獨立頁面的圖片
      if (img.getAttribute('data-standalone-page') === 'true') {
        return;
      }
      
      // 檢查圖片位置關係
      const position = img.compareDocumentPosition(firstTextElement);
      const isPreceding = !!(position & Node.DOCUMENT_POSITION_FOLLOWING);
      
      // 圖片不在第一個.text之前（不是標題圖片）
      const isNotPreceding = !isPreceding;
      
      // 圖片不在最後一個.text之後（不是最後一頁的圖片）
      // 但如果只有一個.text元素，且圖片在第一個.text之後，則視為內容圖片
      let isNotFollowing = true;
      if (lastTextElementAtThisPoint) {
        // 如果只有一個.text元素，且圖片在第一個.text之後，則視為內容圖片
        if (allTextElements.length === 1 && isNotPreceding) {
          isNotFollowing = true; // 只有一個.text時，圖片在第一個.text之後就是內容圖片
        } else {
          const followingPosition = lastTextElementAtThisPoint.compareDocumentPosition(img);
          const isFollowing = !!(followingPosition & Node.DOCUMENT_POSITION_FOLLOWING);
          isNotFollowing = !isFollowing;
        }
      }
      
      // 圖片不在任何.text元素內部
      const isNotInsideText = !Array.from(allTextElements).some(textEl => 
        textEl.contains(img)
      );
      
      if (isNotPreceding && isNotFollowing && isNotInsideText) {
        contentImages.push(img);
      }
    });
    
    // 如果有內容圖片，需要處理
    if (contentImages.length > 0) {
      // 計算前置的 <br> 和 <img> 數量（標題圖片每個算1行）
      const precedingBrCount = countPrecedingLineElements(firstTextElement);
      
      // 收集第一個 .text 內的所有節點
      const nodes = collectTextNodes(firstTextElement);
      
      // 按照行數限制切分成多頁（計算第一頁內容）
      const pages = splitNodesIntoPages(nodes, precedingBrCount, pageSize, measureContainer, lineHeight, titleHeight, titleLines);
      const firstPageContent = pages[0] || '';
      
      // 測量第一頁文字內容的高度
      const firstPageHTML = `<div class="text">${firstPageContent}</div>`;
      measureContainer.innerHTML = firstPageHTML;
      const firstPageHeight = measureContainer.offsetHeight;
      
      // 計算最大高度限制
      const maxHeight = pageSize * lineHeight;
      
      // 計算標題圖片占用的高度（標題圖片算1行）
      const titleImageHeight = lineHeight; // 標題圖片固定算1行
      
      // 判斷第一頁內容是否已滿
      const totalFirstPageHeight = firstPageHeight + titleImageHeight;
      
      // 使用容錯範圍：如果達到 90% 以上，就視為已滿
      const tolerance = Math.max(maxHeight * 0.1, 1); // 10% 或至少 1px
      const isFirstPageFull = totalFirstPageHeight >= (maxHeight - tolerance);
      
      // 如果第一頁已滿，且有內容圖片，必須創建第二頁
      if (isFirstPageFull && contentImages.length > 0) {
        // 將內容圖片標記為在第二頁顯示
        contentImages.forEach(img => {
          img.setAttribute('data-content-image', 'true');
          img.setAttribute('data-second-page', 'true');
        });
        
        // 如果只有一頁，創建.text作為第二頁來放置圖片
        if (actualTotalPages === 1) {
          const emptyTextDiv = doc.createElement('div');
          emptyTextDiv.className = 'text';
          
          // 在第一個.text之後插入空的.text
          const firstTextParent = firstTextElement.parentNode;
          const firstTextNextSibling = firstTextElement.nextSibling;
          if (firstTextNextSibling) {
            firstTextParent.insertBefore(emptyTextDiv, firstTextNextSibling);
          } else {
            firstTextParent.appendChild(emptyTextDiv);
          }
          
          actualTotalPages = 2;
        }
      }
    }
  }

  // 重新計算總頁數（因為可能新增了空的.text）
  const finalTextElements = doc.querySelectorAll('.text');
  actualTotalPages = finalTextElements.length;

  // 返回修改後的 HTML 字串和總頁數
  return {
    htmlString: doc.body.innerHTML,
    totalPages: actualTotalPages || 1,
  };
};
